module.exports = __webpack_public_path__ + "static/media/awad3.4ae02e91.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/awad3.png
// module id = 1664
// module chunks = 0